import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { AddItemModalContent } from './AddItemModalContent'
import { ContentStates, useContext } from './Context'
import { AddBoardModalContent } from './AddBoardModalContent'
import { ShowIf } from '@ztechapps/webui.util'

export const AddToBoardButton = ({ triggerComponent, itemInfoComponent, addItemContent, addBoardContent }) => {
  //get all boards
  const { onShow, onClose, show, contentState, list, entity } = useContext()

  addItemContent = addItemContent ?? <AddItemModalContent />
  addBoardContent = addBoardContent ?? <AddBoardModalContent />

  return (
    <React.Fragment>
      {triggerComponent({ onClick: onShow })}

      <Modal show={show} onHide={onClose} centered size="lg" scrollable>
        <Modal.Body>
          <div className="mb-2">
            <Row>
              <Col lg={4}>{itemInfoComponent({ entity })}</Col>
              <Col lg={8} className="my-2 ">
                <ShowIf condition={contentState === ContentStates.addItem && !isEmpty(list)}>{addItemContent}</ShowIf>
                <ShowIf condition={contentState === ContentStates.addBoard || isEmpty(list)}>{addBoardContent}</ShowIf>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}
